import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import Watermark from './Watermark';
import ArchImage from './ArchImage';
import Ornament from './Ornament';

/**
 * PageHero — cream band with breadcrumbs, serif title, subtitle and an
 * optional arched image (two-column when `image` is given).
 */
export default function PageHero({ crumbs, title, subtitle, image, imageAlt = '', children, className = '', compact = false }) {
  return (
    <section className={`page-hero${image ? ' page-hero--media' : ''}${compact ? ' page-hero--compact' : ''}${className ? ` ${className}` : ''}`}>
      <Watermark variant="mandala" position="top-right" />
      <div className="container page-hero__inner">
        <div className="page-hero__text">
          {crumbs && <Breadcrumbs items={crumbs} />}
          <h1 className="h-display page-hero__title">{title}</h1>
          {subtitle && (
            <p className="page-hero__sub">
              {subtitle}
              <Ornament compact />
            </p>
          )}
          {children}
        </div>
        {image && (
          <div className="page-hero__media">
            <ArchImage src={image} alt={imageAlt} ratio="5/4" />
          </div>
        )}
      </div>
    </section>
  );
}
